import { PPSL_AUDITS_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/ppsl_audits_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator(['ppslAuditsIndex', 'partAuditsIndex']);

export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
